import { faArrowRotateLeft } from "@fortawesome/pro-regular-svg-icons";

import { T } from "@repo/transifex";
import { Button } from "~/components";
import {
  DiscoveryEmptyIcon,
  DiscoveryErrorIcon,
  DiscoveryState
} from "~/components/collect/discovery-state";
import { GridSkeleton } from "~/components/collect/grid-skeleton";
import { type UserGridProps } from "~/components/collect/operator/user-grid";

import { type DiscoveryView } from "./discovery-view";
import { StudentsGrid } from "./students-grid";

type DiscoveryMainProps = {
  view: DiscoveryView;
  onRetry: () => void;
  isRetrying: boolean;
  onClearFilters: () => void;
  rows: number;
  columns: NonNullable<UserGridProps["columns"]>;
};

export const DiscoveryMain = ({
  view,
  onRetry,
  isRetrying,
  onClearFilters,
  rows,
  columns
}: DiscoveryMainProps) => {
  switch (view) {
    case "error":
      return (
        <DiscoveryState>
          <DiscoveryErrorIcon />
          <DiscoveryState.Title>
            <T _str="Couldn't load students" />
          </DiscoveryState.Title>
          <Button
            variant="neutral"
            size="medium"
            icon={faArrowRotateLeft}
            disabled={isRetrying}
            onClick={onRetry}
          >
            <T _str="Retry" />
          </Button>
        </DiscoveryState>
      );
    case "loading":
      return <GridSkeleton rowsCount={rows} columnsCount={columns} />;
    case "no-match":
      return (
        <DiscoveryState>
          <DiscoveryEmptyIcon />
          <DiscoveryState.Title>
            <T _str="No students match" />
          </DiscoveryState.Title>
          <Button
            variant="neutral"
            size="medium"
            icon={faArrowRotateLeft}
            onClick={onClearFilters}
          >
            <T _str="Clear all filters" />
          </Button>
        </DiscoveryState>
      );
    case "no-status":
    case "empty":
      return (
        <DiscoveryState>
          <DiscoveryEmptyIcon />
          <DiscoveryState.Title>
            <T _str="No students found" />
          </DiscoveryState.Title>
        </DiscoveryState>
      );
    case "grid":
      return <StudentsGrid columns={columns} />;
  }
};
